/* eslint-disable react/jsx-props-no-spreading */

import { observer } from 'mobx-react-lite';
import { CheckboxField } from '../../../../components';
import { Button } from '../../../../components/controls';
import { Title } from '../../../../components/display';
import { SelectField, TextField } from '../../../../components/form';
import { PulseKeyStatusOptions } from '../../../../store/constants/pulseKeys';
import KeyLabelField from '../../../products/edit/pulse-keys/components/KeyLabelField';
import PulseKeySearch from '../../store/PulseKeySearch';

export default observer(function Filters({
  controlWidth = 240,
  search,
}: {
  controlWidth?: number;
  search: PulseKeySearch;
}) {
  return (
    <>
      <Title sx={{ mb: -1, mt: 0 }}>Filters</Title>
      <SelectField
        clear
        label="Product"
        name="filters.sellableId"
        onChange={search.handleChange}
        options={search.products.toOptions(
          'Not set',
          !search.filters.skipArchived,
        )}
        required
        sx={{ mr: 1, width: controlWidth }}
        value={search.filters.sellableId}
      />
      <KeyLabelField
        clear
        displayEmpty={false}
        label="Label"
        onChange={(value) =>
          search.handleChange({ name: 'filters.label', value })
        }
        sx={{ mr: 1, mt: 2, width: controlWidth }}
        value={search.filters.label}
      />
      <TextField
        clear
        label="Customer email"
        name="filters.email"
        onChange={search.handleChange}
        sx={{ mr: 1, width: controlWidth }}
        value={search.filters.email}
      />
      <TextField
        clear
        label="Pulse Key"
        name="filters.key"
        onChange={search.handleChange}
        sx={{ mr: 1, width: controlWidth }}
        value={search.filters.key}
      />
      <SelectField
        clear
        label="Status"
        name="filters.status"
        onChange={search.handleChange}
        options={[{ label: <i>Any</i>, value: '' }, ...PulseKeyStatusOptions]}
        sx={{ mr: 1, width: controlWidth }}
        value={search.filters.status}
      />

      <div>
        <CheckboxField
          disabled={Boolean(search.filters.sellableId)}
          label="Hide archived"
          name="filters.skipArchived"
          onChange={search.handleChange}
          value={search.filters.skipArchived && !search.filters.sellableId}
        />
      </div>

      <div>
        <Button
          icon="search"
          onClick={search.search}
          sx={{ mt: 2 }}
          type="primary"
        >
          Search
        </Button>
      </div>
    </>
  );
});
